import gsap from 'gsap'
import { debounce, stLineWrap } from '../utils'
import SplitType from 'split-type'

const insights = (container, isTouchScreen, isTouch) => {
  const sel = (el) => container.querySelector(el)
  const selAll = (el) => container.querySelectorAll(el)
  if (!sel('.insight__item')) return
  const stagger = sel('[data-stagger]')
  // if (!sel('.insight__item')) return console.log('No insight items found')

  function easeRev(timeline) {
    // We'll return an actual function that GSAP can call per frame
    return function (p) {
      if (timeline.reversed()) {
        // console.log('reversed')
        const backwardEase = gsap.parseEase('power1.in')
        // Typically p goes from 1 -> 0 in reverse, so we might do:
        const reversedP = 1 - p
        return 1 - backwardEase(reversedP)
      } else {
        // console.log('forward')
        const forwardEase = gsap.parseEase('power4.out')
        return forwardEase(p)
      }
    }
  }
  function _insight(items = []) {
    return gsap.context(() => {
      let itemsArr
      // setTimeout(() => {
      // console.log(items)
      if (items.length > 0) {
        itemsArr = items
        // console.log(itemsArr)
      }
      // }, 500)
      const insightItem$a = itemsArr || selAll('.insight__item')

      if (!insightItem$a.length) return console.warn('No collection items found')
      if (!itemsArr) {
        gsap.from(insightItem$a, {
          x: 50,
          opacity: 0,
          // if _insight called by fs filter or load, stagger 0.3, else 2
          stagger: stagger ? { each: stagger.dataset.stagger / 1000 } : { amount: 2 },
          duration: 2,
          ease: 'power4.out',
          scrollTrigger: { trigger: insightItem$a[0], start: 'top 80%', end: '+=1', toggleActions: 'play none reverse none' },
        })
      }
      if (isTouch) return

      insightItem$a.forEach((el) => {
        const insightCat$ = el.querySelector('.insight__item__category:not(.is--secondary)')
        if (insightCat$ && !insightCat$.stInit) {
          insightCat$.stInit = true
          stLineWrap(insightCat$, 'insight__item__category-w')
          // const sec$ = insightCat$.querySelector('.is--secondary')

          let div = document.createElement('div')
          div.classList.add('insight__item__category', 'is--secondary')
          div.textContent = insightCat$.textContent
          insightCat$.after(div)
          // console.log(insightCat$)
        }

        const insightCatW$ = el.querySelector('.insight__item__category-w')
        if (insightCatW$) {
          const insightItem$ = el
          const insightA$ = insightItem$.querySelector('a')
          const catPrim$ = el.querySelector('.insight__item__category:not(.is--secondary)')
          const catSec$ = el.querySelector('.insight__item__category.is--secondary')

          // TODO turn into async (observer?)
          // no idea why but SplitType has to be offset with finsweet filter
          setTimeout(() => {
            const paneParent$ = insightItem$.closest('.w-tab-pane:not(.w--tab-active)')

            function tabCategoryStInit() {
              console.log('tabCategoryStInit')
            }

            if (paneParent$ !== null) {
              // tabCategoryStInit()
              const observer = new IntersectionObserver(
                (entries, observer) => {
                  entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                      paneInit()
                      console.log('Intersecting', entry.target)
                      observer.unobserve(entry.target)
                    }
                  })
                }
                // { threshold: 0.1 }
              )
              observer.observe(paneParent$)
            } else {
              paneInit()
            }
            function paneInit() {
              const catPrimSt = catPrim$?.st || new SplitType(catPrim$, { types: 'lines, words, chars', lineClass: 'st-line' })
              if (!catPrim$.st) catPrim$.st = catPrimSt
              // console.log(catPrim$?.st)

              const catSecSt = catSec$?.st || new SplitType(catSec$, { types: 'lines, words, chars', lineClass: 'st-line' })

              if (!catSec$.st) {
                catSec$.st = catSecSt
                // delete catSec$.st
                gsap.set(catSecSt.chars, { y: '1.2em' })

                const charEase = 'power4.out'
                const insightCatTl = gsap.timeline({ defaults: { duration: 1, ease: 'none' }, paused: true })
                // console.log(catPrimSt.chars)

                insightCatTl
                  .to(catPrimSt.chars, { y: '-1.2em', stagger: { amount: 0.5 }, ease: charEase, duration: 0.2 }, 0)
                  .to(catSecSt.chars, { y: '0em', stagger: { amount: 0.5 }, ease: charEase, duration: 0.2 }, 0)
                  .to(
                    insightA$,
                    {
                      x: !isTouchScreen && 20,
                      duration: 1,
                      ease: easeRev(insightCatTl),
                    },
                    0
                  )

                // insightItem$.addEventListener('mouseenter', () => {
                insightItem$.onmouseenter = () => {
                  insightCatTl.reversed(false)

                  // insightCatTl.play()
                  gsap.to(insightCatTl, { duration: 1, progress: 1, ease: 'power1.out' })
                }
                // insightItem$.addEventListener('mouseleave', () => {
                insightItem$.onmouseleave = () => {
                  insightCatTl.reversed(true)

                  // insightCatTl.reverse()
                  gsap.to(insightCatTl, { duration: 1, progress: 0, ease: 'power4.out' })
                }
              }
            }
          }, 1000)
        }
      })
    })
  }

  let ctx = _insight()

  // fsAttributes.push is not working for load more after barba transition
  const list = debounce(() => {
    const insightItems = selAll('.insight__item')
    // console.log('list', insightItems.length)
    // ctx.revert()
    ctx = _insight(insightItems)
  })
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        list()
      }
    })
  })
  const insightContainer = sel('.insight__list')
  if (insightContainer) observer.observe(insightContainer, { childList: true })

  return ctx
}
export default insights
